import { RedirectToSignIn, SignedIn, SignedOut } from "@clerk/clerk-react";
import { Navigate, createFileRoute } from "@tanstack/react-router";

/**
 * Root landing for the admin web surface.
 *
 * Web has been rescoped post-pivot to a desktop / admin client
 * (signup, settings, billing, account export, share-recipient view).
 * Signed-in users land in account settings; signed-out users go
 * through the Clerk sign-in flow. The jobsite capture client is a
 * separate native app (Android first, see `CLAUDE.md`).
 */
export const Route = createFileRoute("/")({
  component: IndexPage,
});

function IndexPage() {
  return (
    <>
      <SignedIn>
        <Navigate to="/settings/account" />
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}
